import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { RECEIVE_STATUS_LABEL } from '../utils/utils';
import type { ScanSearchResultItem } from '../types/types';

type SearchResultItemProps = {
	item: ScanSearchResultItem;
	selected: boolean;
	onClick: (bibNumber: string) => void;
};

// 직접 검색 결과 행
const SearchResultItem = memo<SearchResultItemProps>(({ item, selected, onClick }) => {
	return (
		<Wrapper $selected={selected} onClick={() => onClick(item.bibNumber)}>
			<Info>
				<TopLine>
					<Name>{item.maskedName}</Name>
					<Course>{item.courseName}</Course>
					<Phone>{item.phoneNumber}</Phone>
				</TopLine>
				<ReceiveStatus>{RECEIVE_STATUS_LABEL[item.receiveStatus]}</ReceiveStatus>
			</Info>
			<Bib>{item.bibNumber}</Bib>
		</Wrapper>
	);
});

SearchResultItem.displayName = 'SearchResultItem';

export default SearchResultItem;

const Wrapper = styled.div<{ $selected: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px 24px;
	cursor: pointer;
	border-bottom: 1px solid ${({ theme }) => theme.colors.ultraLightGrayBorder};
	transition: 0.2s;

	&:hover {
		background-color: ${({ theme }) => theme.colors.lightGrayHoverColor};
	}

	${({ $selected }) =>
		$selected &&
		css`
			background-color: #eaf3ff;

			&:hover {
				background-color: #eaf3ff;
			}
		`};
`;
const Info = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;
const TopLine = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;
const Name = styled.span`
	font-size: 16px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
`;
const Course = styled.span`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
`;
const Phone = styled.span`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
`;
const ReceiveStatus = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
`;
const Bib = styled.div`
	font-size: 22px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
`;
